import React from 'react'
import { Upload } from 'antd'

const UploadComponent = ({ handleOnChange, customRequest, listType, accept, showUploadList, children, filesList, disabled, maxCount, onRemove }) => {
  return (
    <Upload
      accept={accept}
      customRequest={customRequest}
      onChange={handleOnChange}
      showUploadList={showUploadList}
      listType={listType}
      disabled={disabled}
      fileList={filesList}
      maxCount={maxCount}
      onRemove={onRemove}
    >
      {children}
    </Upload>
  )
}

export default UploadComponent
